<template>
  <Icon :icon="`mmcdn:${icon}`" />
</template>

<script>
import { Icon } from '@iconify/vue';
import { addAPIProvider } from '@iconify/vue';
addAPIProvider('mmcdn', {
  resources: ['https://iconify.mmcdn.de'],
});

export default {
  props: {
    icon: {
      type: String,
      required: true,
    }
  },
  components: {
    Icon,
  },
}
</script>

